import axiosIns from '@/libs/axios'
import dispatchCached from '@/utils/local-storage'

export default {
  namespaced: true,
  state: {
    zones: [],
    selectedZone: null,
  },
  getters: {
    zones: state => state.zones,
    selectedZone: state => state.selectedZone,
  },
  mutations: {
    SET_ZONES: (state, zones) => {
      state.zones = zones
    },
    SET_SELECTED_ZONE: (state, zone) => {
      state.selectedZone = zone
    },
  },
  actions: {
    updateZoneConfiguration(_, { zone, configurations }) {
      return axiosIns.put(`/zones/geospatials/${zone}/configurations`, {
        configurations,
      })
    },
    fetchZones({ commit }, params) {
      return new Promise((resolve, reject) => {
        const userData = JSON.parse(localStorage.getItem('userData'))
        const userCountry = userData?.country || 'JO'
        axiosIns
          .get('/zones', {
            params: {
              country: userCountry === 'JO' ? 'Jordan' : 'Libya',
              page: params?.page || undefined,
              perPage: params?.perPage || undefined,
              city: params?.city || undefined,
            },
          })
          .then(response => {
            const { data } = response.data
            commit('SET_ZONES', data)
            resolve(data)
          })
          .catch(error => reject(error))
      })
    },
    async fetchZoneNames({ dispatch }) {
      const zoneList = await dispatch('fetchZones')
      const zoneNames = {}
      zoneList.forEach(el => {
        zoneNames[`${el.country}::${el.city}`] = ''
      })
      return zoneNames
    },
    async fetchZoneNamesCached({ dispatch }) {
      return dispatchCached(dispatch, 'fetchZoneNames')
    },
    async fetchZoneByServicesCached({ dispatch }) {
      const data = await dispatchCached(dispatch, 'fetchZones')
      const servicesByZone = {}
      for (let i = 0; i < data.length; i += 1) {
        const zone = `${data[i].country}::${data[i].city}`
        servicesByZone[zone] = data[i].services
      }
      return servicesByZone
    },
    fetchZonesServices(ctx, zone) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`/zones/${zone}/services`)
          .then(response => {
            resolve(response.data.data)
          })
          .catch(error => reject(error))
      })
    },
    putZoneServices(ctx, { zone, services }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .put(`/zones/${zone}/services`, { services })
          .then(response => {
            resolve(response.data.data)
          })
          .catch(error => reject(error))
      })
    },
    selectZone({ commit }, zone) {
      commit('SET_SELECTED_ZONE', zone)
    },
    async putZone(ctx, zone) {
      return new Promise((resolve, reject) => {
        axiosIns
          .put('/zones', zone)
          .then(res => {
            console.log('Submiited', res)
          })
          .catch(err => reject(err))
          .finally(() => resolve())
      })
    },
  },
}
